// A deliberately small rich-text vocabulary: guides cannot introduce executable HTML.
export function safeGuideHtml(value) {
  const parsed = new DOMParser().parseFromString(String(value || ''), 'text/html')
  const allowed = ['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'UL', 'OL', 'LI', 'H2', 'H3', 'H4', 'BLOCKQUOTE', 'A', 'TABLE', 'TBODY', 'TR', 'TD', 'TH', 'SPAN']
  Array.from(parsed.body.querySelectorAll('*')).forEach(node => {
    if (['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'SVG', 'MATH'].includes(node.tagName)) { node.remove(); return }
    if (!allowed.includes(node.tagName)) { node.replaceWith(...node.childNodes); return }
    Array.from(node.attributes).forEach(attribute => {
      if (node.tagName === 'A' && attribute.name === 'href' && /^(https?:\/\/|mailto:|\/[^/]|#)/i.test(attribute.value)) return
      node.removeAttribute(attribute.name)
    })
    if (node.tagName === 'A') node.setAttribute('rel', 'noopener noreferrer')
  })
  return parsed.body.innerHTML
}
export const richEditorConfig = { language: 'fr_FR', base_url: '/tinymce', suffix: '.min', height: 230, menubar: false, branding: false, promotion: false, plugins: ['lists', 'link', 'table'], toolbar: 'undo redo | blocks | bold italic | bullist numlist | link table | removeformat' }
